module.exports = require('./lib/sockjs');



//////////////////
// WEBPACK FOOTER
// ./~/sockjs/index.js
// module id = 3920
// module chunks = 0